import React from 'react';
import PropTypes from 'prop-types';

export const Message = ({ width, height, ...props }) => (
  <svg
    data-icon='message'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm8-7L4 8v10h16V8l-8 5Zm0-2 8-5H4l8 5ZM4 8V6v12V8Z'
    />
  </svg>
);

Message.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Message.defaultProps = {
  width: 24,
  height: 24,
};
